import {getDefaultValues} from '@github-ui/relay-query-cache/helpers'
import {useCallback, useMemo} from 'react'
import {type PreloadedQuery, useQueryLoader, type UseQueryLoaderLoadQueryOptions} from 'react-relay'
import type {GraphQLTaggedNode, OperationType, VariablesOf} from 'relay-runtime'

export const useEntryPointsLoader = <QueryType extends OperationType>(
  initialQueryRef: PreloadedQuery<QueryType> | null | undefined,
  query: GraphQLTaggedNode,
) => {
  const [queryRef, loadQuery, disposeQuery] = useQueryLoader<QueryType>(query, initialQueryRef)

  const defaultValues = useMemo(() => getDefaultValues(query), [query])

  const loaderWithDefaultValues = useCallback(
    (variables: VariablesOf<QueryType>, options?: UseQueryLoaderLoadQueryOptions) => {
      loadQuery(variables, {
        ...options,
        networkCacheConfig: {
          ...options?.networkCacheConfig,
          metadata: {
            ...options?.networkCacheConfig?.metadata,
            defaultValues,
          },
        },
      })
    },
    [loadQuery, defaultValues],
  )

  return {
    queryRef,
    loadQuery: loaderWithDefaultValues,
    disposeQuery,
  }
}
